import styled from 'styled-components'
import {Colors, FontSize} from '../../../../styledComponents/Constants'
import {currentMedia} from '../../../../styledComponents/ResponsiveConvenience'
import {DefaultStyledButton, PrimaryStyledButton} from '../../../../styledComponents/Button'

export const ItemHeading = styled.div`
  background-color: ${Colors.AccentLight};
  ${currentMedia.lessThan('sp')`
    width: calc(100% + 30px);
    margin: 0px -15px;
  `};
  padding: 5px 15px;
  box-sizing: border-box;
  overflow: hidden;
`

export const WideWhiteArea = styled.div`
  background-color: ${Colors.Surface};
  ${currentMedia.lessThan('sp')`
    width: calc(100% + 30px);
    margin: 0px -15px;
  `};
  padding: 0 15px;
  box-sizing: border-box;
  overflow: hidden;
`

export const GuestAuthButton = styled(PrimaryStyledButton)`
  max-width: 315px;
  background: ${Colors.GuestPrimary};
  border: 1px solid ${Colors.GuestPrimary};
  box-shadow: 0 2px 0 0 ${Colors.GuestPrimaryVariant};
  :active {
    background-color: ${Colors.GuestPrimary};
    box-shadow: none;
  }
`

export const GuestAuthBackButton = styled(DefaultStyledButton)`
  max-width: 315px;
  color: ${Colors.GuestPrimary};
  background: ${Colors.Background};
  border: 1px solid ${Colors.GuestPrimary};
  box-shadow: none;
  font-size: ${FontSize.Body};
`